<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<!-- <el-form-item label="联系人姓名" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.linkUser" placeholder="请输入客户名称"></el-input>
					</el-form-item> -->
					<el-form-item>
						<template>
							<!-- <el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button> -->
							<el-button type="primary" @click="downloadFile"> 导出 </el-button>
							
							<el-button type="primary" @click="adduser"> 新增 </el-button>
							
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="routeList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			
			<el-table-column prop="customerId" label="客户ID" align="center" width="90">
			</el-table-column>
			<el-table-column prop="routeName" label="线路名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="fromAddressName" label="出发地简称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="toAddressName" label="到达地简称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="distance" label="距离" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.distance">{{scope.row.distance}}公里</span>
                </template>
			</el-table-column>
			<el-table-column prop="routeMemo" label="备注" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="priceTrips" label="按趟次单价" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span>{{scope.row.priceTrips}}元/趟</span>
                </template>
			</el-table-column>
            <el-table-column prop="priceVolume" label="按方数定价" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span>{{scope.row.priceVolume}}元/方</span>
                </template>
			</el-table-column>
            <el-table-column prop="priceWeight" label="按吨数定价" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span>{{scope.row.priceWeight}}元/吨</span>
                </template>
			</el-table-column>
			<el-table-column prop="driveSendReward" label="运输提成" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span>{{scope.row.driveSendReward}}元</span>
                </template>
			</el-table-column>
            <el-table-column prop="status" label="状态"  align="center" >
                <template slot-scope="scope">
					<span v-if="scope.row.status == 0" style="color: red">停用</span>
					<span v-if="scope.row.status == 1" style="color: green">正常</span>
					<!-- <span v-if="scope.row.status == 2" style="color: #E6A23C">在途</span> -->
                </template>
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column label="操作" align="center">
				　　　　<template slot-scope="scope">
					　　　　　　<el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">
						编辑</el-button>
						<el-button size="small" type="text" @click="toDelete(scope.row.id)">
							删除</el-button>
				</template>
				
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px 0px ;" background :current-page="routeList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="routeList.total"
			@size-change="handleSizeChange">
		</el-pagination>
		
		
		
		<!-- 新增 -->
		<el-dialog style="float:rigin" :title="dialogVisibleFunName" :closeOnClickModal="false"
			:visible.sync="dialogVisibleuser" width="50%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="线路名称" style="width: 55%;" label-width="120px">
							<el-input type="text" clearable v-model="userInfo.routeName" placeholder="请输入线路名称" />
						</el-form-item>

                        <el-form-item label="距离" style="width: 40%;" label-width="80px" >
							<el-input type="text" clearable v-model="userInfo.distance" placeholder="请输入距离" >
								<template slot="append">公里</template>
							</el-input>
						</el-form-item>
					</div>
					<div style="display: flex;justify-content:  space-between;">
						<el-form-item label-width="120px"  label="选择客户" style="width: 55%;">
							<el-select filterable v-model="userInfo.customerId" style="width: 100%" placeholder="请选择" clear >
								<el-option v-for="it in factoryList" :key="it.id" 
                                :value="it.id" :label="it.customerName"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div style="display: flex;justify-content:  space-between;">
						<el-form-item label-width="120px"  label="出发地" style="width: 55%;">
							<el-select filterable v-model="userInfo.fromAddressId" style="width: 100%" placeholder="请选择" clear 
							@change="fromAddress">
								<el-option v-for="it in locationList" :key="it.id" :value="it.id" :label="it.addressName"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label-width="80px"  label="到达地" style="width: 40%;">
							<el-select filterable v-model="userInfo.toAddressId" style="width: 100%" placeholder="请选择" clear 
							@change="toAddress">
								<el-option v-for="it in locationList" :key="it.id" :value="it.id" :label="it.addressName"></el-option>
							</el-select>
						</el-form-item>
					</div>
					<div >
						<div style="display: flex;justify-content: space-between;">
							<el-form-item label="按趟次定价" style="width: 40%;" label-width="120px">
								<el-input  type="number" oninput="value=value.replace(/[^0-9.]/g,'')"
								 v-model="userInfo.priceTrips" placeholder="价格" >
								  <template slot="append">元/趟</template>
								</el-input>
							</el-form-item>
							<el-form-item label="按趟次收入" style="width: 40%;" label-width="120px">
								<el-input  type="number" oninput="value=value.replace(/[^0-9.]/g,'')"
								 v-model="userInfo.incomeTrips" placeholder="价格" >
								  <template slot="append">元/趟</template>
								</el-input>
							</el-form-item>
						</div>
						<div style="display: flex;justify-content: space-between;">
							<el-form-item label="按方数定价" style="width: 40%;" label-width="120px">
								<el-input type="number" oninput="value=value.replace(/[^0-9.]/g,'')" 
								v-model="userInfo.priceVolume" placeholder="价格" >
									<template slot="append">元/方</template>
								</el-input>
							</el-form-item>
							<el-form-item label="按方数收入" style="width: 40%;" label-width="120px">
								<el-input  type="number" oninput="value=value.replace(/[^0-9.]/g,'')"
								 v-model="userInfo.incomeVolume " placeholder="价格" >
								  <template slot="append">元/趟</template>
								</el-input>
							</el-form-item>
						</div>
                       <div style="display: flex;justify-content: space-between;">
						   <el-form-item label="按吨数定价" style="width: 40%;" label-width="120px">
						   	<el-input type="number" oninput="value=value.replace(/[^0-9.]/g,'')"
						   	v-model="userInfo.priceWeight" placeholder="价格" >
						   		<template slot="append">元/吨</template>
						   	</el-input>
						   </el-form-item>
						   <el-form-item label="按吨数收入" style="width: 40%;" label-width="120px">
						   	<el-input  type="number" oninput="value=value.replace(/[^0-9.]/g,'')"
						   	 v-model="userInfo.incomeWeight " placeholder="价格" >
						   	  <template slot="append">元/趟</template>
						   	</el-input>
						   </el-form-item>
                       </div>
						
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<!-- <el-form-item label="状态" label-width="120px" style="width: 40%;">
							 <el-select v-model="userInfo.status" placeholder="请选择状态" clear style="width: 100%">
							 	<el-option :key="0" label="停用" :value="0"></el-option>
							 	<el-option :key="1" label="正常" :value="1"></el-option>
							 	<el-option :key="2" label="在途" :value="1"></el-option>
							 </el-select>			
						</el-form-item> -->
						<el-form-item label="状态" label-width="120px" style="width: 40%;display: flex;align-items: center;">
							<el-switch v-model="userInfo.status" :active-value="1" :inactive-value="0">
							</el-switch>
						</el-form-item>
						<el-form-item label="运输提成" style="width: 40%;" label-width="80px">
							<el-input  type="number" oninput="value=value.replace(/[^0-9.]/g,'')" 
							v-model="userInfo.driveSendReward" placeholder="请输入运输提成" >
								<template slot="append">元</template>
							</el-input>
						</el-form-item>
                    </div>
					<div>
						<el-form-item label="备注" label-width="120px" >
							<el-input type="textarea" :rows="5" v-model="userInfo.routeMemo"  maxlength="32" show-word-limit
							placeholder="请输入备注" />
						</el-form-item>
					</div>
                   
                   
					<!-- <div style="display: flex;align-items: center;">
                       <el-form-item label="照片" label-width="120px" style="width: 100%;display: flex;align-items: initial;">
							<br />
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :file-list="fileList" :show-file-list="true" 
								:on-success="onSuccess">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
					</div>
					 -->
					
		
				</el-form>
			</div>
			<div style="text-align: center;margin-top: 100px;">
				<el-button @click="dialogVisibleuser = false">取 消</el-button>
				<el-button v-if="dialogVisibleFunName == '新增'" type="primary" @click="add" :loading="addLoading">添 加</el-button>
				<el-button v-if="dialogVisibleFunName == '编辑'" type="primary" @click="sure" :loading="sureLoading">编 辑</el-button>
			</div>
		</el-dialog>
		

	</div>
</template>

<script>
	export default {
		components: {

		},  
		data() {
			return {
				userInfo:{
					status:1
				},
				loading: false,
				routeList: [{}], //用户列表

				dialogVisibleFunName:'',

				formLabelWidth: "200px", 

				page: {
					pageNum: 1,
					pageSize: 10
				},
                searchInfo: {},
                
				//新增弹窗
				dialogVisibleuser:false,

                popupType: 1, //弹窗类型
                dialogHtml:"",

                factoryList: [],
                froductListShow: [],
                
                addLoading: false,
				sureLoading: false,
				
				locationList: []
			};
		},
		methods: {
			//导出
			downloadFile() {
				let data = {
					// ...this.orderInfo
				};
				// console.log(data);
				this.$api.routeListExportExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "运输路线" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
            fromAddress(e){
				let obj = {};
				obj = this.locationList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.userInfo.fromAddressName = obj.addressName
			},
			toAddress(e){
				let obj = {};
				obj = this.locationList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.userInfo.toAddressName = obj.addressName 
			},
            districtFcus(e) { 
				this.userInfo.areaId = e 
				let obj = {};
				obj = this.districtList.find((item) => { 
					return item.id === e; //筛选出匹配数据
				});
				this.userInfo.area = obj.name
			},
            sure() { //编辑
                this.sureLoading = true
				let data = {
					customerId: this.userInfo.customerId,
					routeName: this.userInfo.routeName,
					
                    fromAddressName: this.userInfo.fromAddressName,
					fromAddressId: this.userInfo.fromAddressId,
					toAddressName: this.userInfo.toAddressName,
					toAddressId: this.userInfo.toAddressId,
					incomeTrips :this.userInfo.incomeTrips,
					incomeVolume : this.userInfo.incomeVolume ,
					incomeWeight: this.userInfo.incomeWeight,
                    distance: this.userInfo.distance, 
                    routeMemo: this.userInfo.routeMemo,
					priceTrips :this.userInfo.priceTrips,
					priceVolume: this.userInfo.priceVolume,
					priceWeight: this.userInfo.priceWeight,
					driveSendReward: this.userInfo.driveSendReward,
					status: this.userInfo.status,

                    id: this.userInfo.id
				}
			
				this.$api.updateRoutet(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getRouteList()
					} else {
						this.$message.error(res.message);
                    }
                    
					this.sureLoading = false
					this.dialogVisibleuser = false;
				})
			},
			add(){
				this.addLoading = true;
				// console.log('新增信息---', data)
				let data={
                    customerId: this.userInfo.customerId,
					routeName: this.userInfo.routeName,
					
                    fromAddressName: this.userInfo.fromAddressName,
					fromAddressId: this.userInfo.fromAddressId,
					toAddressName: this.userInfo.toAddressName,
					toAddressId: this.userInfo.toAddressId,
					
                    distance: this.userInfo.distance, 
                    routeMemo: this.userInfo.routeMemo,
					priceTrips :this.userInfo.priceTrips,
					priceVolume: this.userInfo.priceVolume,
					
					incomeTrips :this.userInfo.incomeTrips,
					incomeVolume : this.userInfo.incomeVolume ,
					incomeWeight: this.userInfo.incomeWeight,
					
					priceWeight: this.userInfo.priceWeight,
					driveSendReward: this.userInfo.driveSendReward,
					status: this.userInfo.status,
                }
                // console.log('新增信息---', data)
				this.$api.addRoutet(data).then(res=>{
                    if(res.state=='success'){
                        this.$message({
                            message: res.message,
                            type: 'success'
                        });
                        this.dialogVisibleuser = false;
                        this.userInfo={}
                        this.getRouteList();
                    }
                    this.addLoading = false;
				})
			},
			factoryNoPage(){
				this.$api.routetAddress().then((res) => { 
						res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
                        // console.log('地址---', res.data)
                        this.locationList = res.data
					}else{

                    }
				})

				this.$api.factoryNoPage(this.$encrypt({})).then((res) => { 
						res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
                        // console.log('客户---', res.data)
                        this.factoryList = res.data
					}else{

                    }
				})
			},

			adduser(){
				this.userInfo={
					status:1
				}
				this.dialogVisibleuser=true
				this.factoryNoPage();
				this.dialogVisibleFunName='新增'
			},
			// 编辑弹窗
			dialogVisibleFun(id) {
				this.factoryNoPage();
                this.$api.getRoutetByID(id).then(res=>{
                    if(res.state == 'success'){
						// console.log('123--', res.data)
                        this.userInfo = res.data;
                    }
                    
                })
				this.dialogVisibleuser=true
				this.dialogVisibleFunName='编辑'
			
			},
			
            changeProduct(row, column, cellValue){ //处理主营产品
                let list = [];
                let arr = cellValue.split(',');
                this.getProductList.forEach((item)=>{
                    if( arr.indexOf(item.id+'') != -1 ){
                        list.push(item.className)
                    }
                })
                return list.join(',')
            },
			changeNull(row, column, cellValue) { //处理数据为null的情况
				if (cellValue) {
					return cellValue;
				} else {
					return "暂无";
				}
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getRouteList()
			},
			//删除
			toDelete(row) {
				var str = "确认删除该线路, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					
					this.$api.delRoutet(row).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getRouteList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time
						.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			pageChange(data) {
				this.page.pageNum = data
				this.getRouteList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getRouteList()
			},
			getRouteList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					// ...this.searchInfo
				
				}
				this.$api.getRoutetList(data).then((res) => { 
					// console.log('运输线路管理列表:', res);
					if (res.state == 'success') {
						this.routeList = res.data
						this.loading = false
					}
				})
			},

            productList(){
                let data = {
					pageNum: 1,
					pageSize: 50,
				}
                this.$api.getProductList(data).then((res) => { 
					if (res.state == 'success') {
                        // console.log('产品---', res.data.list)
                        this.getProductList = res.data.list
					}else{

                    }
				})
            },
		},
		created() {
			this.getRouteList();
		}
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>
